import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function Network() {
  return (
    <Page
      title='Network'
      breadcrumbs={[
        {
          label: 'Global Settings',
        },
        {
          label: 'Network',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/global-settings/network',
  component: Network,
  type: 'auth',
});
